import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { AddKatexRendering } from './AddKatexRendering';

export const techdocsAddonKatexPlugin = createPlugin({
  id: 'techdocs-addon-katex',
});

export const Katex = techdocsAddonKatexPlugin.provide(
  createTechDocsAddonExtension({
    name: 'Katex',
    location: TechDocsAddonLocations.Content,
    component: AddKatexRendering,
  }),
);
